<section class="part-usage-card" *transloco="let t; prefix: 'parts.modals'">
  <div class="part-usage-card__header">
    <h3>{{ t('partUsage.title') }}</h3>

    <div class="part-usage-card__actions">
      <app-date-filter
        [filter]="dateFilter"
        [isButtonIntervalSelector]="false"
        [disabledIntervals]="disabledIntervals"
        [defaultInterval]="defaultInterval"
        [datePickerPlacement]="'top'"
        (filterChanged)="onDateFilterChange($event)">
      </app-date-filter>

      <button type="button" class="add-stock-btn" (click)="openAddStock()">
        {{ t('partUsage.addStock') }}
      </button>
    </div>
  </div>

  <div class="part-usage-table">
    <table class="table">
      <thead>
        <tr>
          <th>{{ t('partUsage.columnDate') }}</th>
          <th>{{ t('partUsage.columnUser') }}</th>
          <th>{{ t('partUsage.columnStockBefore') }}</th>
          <th>{{ t('partUsage.columnQtyRequested') }}</th>
          <th>{{ t('partUsage.columnReturned') }}</th>
          <th>{{ t('partUsage.columnWorkOrder') }}</th>
        </tr>
      </thead>
    </table>

    <div
      class="part-usage-table__body"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="1.5"
      [infiniteScrollThrottle]="150"
      (scrolled)="onScrollDown()">
      @if (isUsageLoading) {
        <div class="state-container">
          <div class="spinner-border text-danger" role="status"></div>
        </div>
      } @else if (hasError) {
        <div class="state-container">
          <app-error-state></app-error-state>
        </div>
      } @else if (shouldShowEmptyState) {
        <div class="state-container">
          <app-empty-state></app-empty-state>
        </div>
      } @else {
        <table class="table body-table">
          <tbody>
            @for (item of usageHistory; track trackByUsage(item)) {
              <tr>
                <td>{{ item.date | date:'dd/MM/yyyy' }}</td>
                <td>{{ item.user || '-' }}</td>
                <td>{{ item.stockBefore ?? '-' }}</td>
                <td>{{ item.quantityRequested ?? '-' }}</td>
                <td>{{ item.returned ?? '-' }}</td>
                <td>{{ item.workOrderNumber || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>

        @if (isLoadingMore) {
          <div class="load-more-spinner">
            <span class="spinner-border text-danger" role="status"></span>
          </div>
        }
      }
    </div>
  </div>
</section>